import React from 'react';

import {
  Footer,
  Nav,
  QrProvider,
  SkipLink,
  usePageChrome,
} from './typesetter/shared';
import { PRIVACY_PATH, SUPPORT_EMAIL, content } from './typesetter/content.mjs';

export default function TypesetterPrivacyPage() {
  usePageChrome({
    title: content.meta.privacyTitle,
    description: content.meta.privacyDescription,
    path: PRIVACY_PATH,
  });

  const policy = content.privacyPolicy;

  return (
    <div className="ts-page" id="ts-top">
      <QrProvider>
        <SkipLink />
        <Nav />

        <main id="ts-main">
          <article className="ts-container ts-prose">
            <span className="ts-label">{content.fullName}</span>
            <h1>{content.meta.privacyTitle}</h1>
            <p className="ts-updated">Last updated {policy.updated}</p>
            <p className="ts-intro">{policy.intro}</p>

            <ul className="ts-facts ts-prose-facts">
              {policy.summary.map((fact) => (
                <li key={fact.title}>
                  <strong>{fact.title}</strong>
                  <span>{fact.body}</span>
                </li>
              ))}
            </ul>

            {policy.sections.map((section) => (
              <section key={section.heading}>
                <h2>{section.heading}</h2>
                {section.paragraphs.map((p) => (
                  <p key={p}>{p}</p>
                ))}
                {section.contact && (
                  <p>
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                  </p>
                )}
              </section>
            ))}
          </article>
        </main>

        <Footer />
      </QrProvider>
    </div>
  );
}
